import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md border-b" style={{ backgroundColor: 'rgba(42, 31, 26, 0.95)', borderColor: '#3a2a23' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <div 
            className="flex items-center cursor-pointer group" 
            onClick={() => scrollToSection('hero')}
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_guelph-electric/artifacts/8iae4xfm_IMG_1075.jpeg"
              alt="Janes Electrical Services"
              className="h-12 md:h-14 w-auto transform group-hover:scale-105 transition-transform duration-300 rounded-lg"
              style={{ 
                mixBlendMode: 'lighten',
                filter: 'brightness(1.1)'
              }}
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6 lg:gap-8">
            <button 
              onClick={() => scrollToSection('services')} 
              className="text-sm font-semibold tracking-wide transition-colors duration-200 hover:opacity-80"
              style={{ color: '#d4c19c', fontFamily: "'Rajdhani', sans-serif" }}
            >
              SERVICES
            </button>
            <button 
              onClick={() => scrollToSection('areas')} 
              className="text-sm font-semibold tracking-wide transition-colors duration-200 hover:opacity-80"
              style={{ color: '#d4c19c', fontFamily: "'Rajdhani', sans-serif" }}
            >
              SERVICE AREAS
            </button>
            <Button 
              onClick={() => scrollToSection('contact')} 
              className="font-semibold px-5 lg:px-6 rounded-lg transition-all duration-200 hover:opacity-90"
              style={{ backgroundColor: '#d4c19c', color: '#2a1f1a', fontFamily: "'Rajdhani', sans-serif" }}
            >
              CONTACT US
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            style={{ color: '#d4c19c' }}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t" style={{ borderColor: '#3a2a23' }}>
            <nav className="flex flex-col gap-3">
              <button 
                onClick={() => scrollToSection('services')} 
                className="text-left py-2 font-semibold tracking-wide transition-colors duration-200"
                style={{ color: '#d4c19c', fontFamily: "'Rajdhani', sans-serif" }}
              >
                SERVICES
              </button>
              <button 
                onClick={() => scrollToSection('areas')} 
                className="text-left py-2 font-semibold tracking-wide transition-colors duration-200"
                style={{ color: '#d4c19c', fontFamily: "'Rajdhani', sans-serif" }}
              >
                SERVICE AREAS
              </button>
              <Button 
                onClick={() => scrollToSection('contact')} 
                className="font-semibold w-full mt-2"
                style={{ backgroundColor: '#d4c19c', color: '#2a1f1a', fontFamily: "'Rajdhani', sans-serif" }}
              >
                CONTACT US
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
